<template>
  <div class="sharing-block">
    <div v-on-clickaway="hideUrlHistory" class="link">
      <label>
        {{ $tr('vacancy.preferences.settings.openRegistration') }}

        <img
          v-tooltip="{
            content: $tr('vacancy.preferences.settings.openRegistrationHelper'),
            placement: 'top-center',
            classes: 'tight tight-330'
          }"
          class="vmodule_icon-lock"
          src="/static/images/elements/vmodule-icon-info.svg"
        />
      </label>

      <div class="link__row">
        <div :class="['link__custom', { link__custom_error: !valid_link }]" @click="toggleUrlHistory(true)">
          <div class="link__domain">
            <span>{{ domain }}</span>
          </div>

          <vinput
            id="registrationLink"
            v-model="url_path"
            class="link__area"
            :max="40"
            @input="update_link"
            @focus="focus_area"
          />
        </div>

        <transition>
          <div class="link_btns">
            <template v-if="isIos">
              <vbutton
                class="right-button"
                text_color="grey"
                color="grey"
                icon="icon_copy2"
                :disabled="blocked"
                @click="copy"
              />

              <vbutton
                class="link-button link-button_right"
                color="grey"
                icon="icon_preview"
                :disabled="blocked"
                @click="preview"
              />
            </template>

            <template v-else>
              <vbutton
                v-tooltip="{
                  content: $tr(copyButtonTooltip),
                  trigger: 'hover',
                  placement: 'top-center'
                }"
                class="link-button"
                color="grey"
                icon="icon_copy2"
                :disabled="blocked"
                @click="copy"
              />

              <vbutton
                v-tooltip="{
                  content: $tr(previewButtonTooltip),
                  trigger: 'hover',
                  placement: 'top-center'
                }"
                class="link-button link-button_right"
                color="grey"
                icon="icon_preview"
                :disabled="blocked"
                @click="preview"
              />
            </template>
          </div>
        </transition>
      </div>

      <transition name="fade">
        <url-history
          v-if="isUrlHistoryVisible && urlHistory && urlHistory.length"
          class="history-section"
          :list="urlHistory"
          :domain="domain"
          @submit="hideUrlHistory"
        />
      </transition>
    </div>

    <div :class="['link-help', { 'link-help__error': !valid_link }]">
      {{ $tr('vacancy.preferences.settings.linkHelp') }}
    </div>

    <div v-if="subdomain === 'ai'">
      <social-sharing :url="custom_link" inline-template>
        <div class="sharing-list">
          <network network="facebook" class="sharing-item sharing-item__fb">
            <img src="/static/icons/facebook.svg" alt="Facebook" />
          </network>

          <network network="linkedin" class="sharing-item sharing-item__ln">
            <img src="/static/icons/linkedin.svg" alt="Linkedin" />
          </network>

          <network network="twitter" class="sharing-item sharing-item__tw">
            <img src="/static/icons/twitter.svg" alt="Twitter" />
          </network>
        </div>
      </social-sharing>
    </div>

    <div v-else>
      <social-sharing :url="custom_link" inline-template>
        <div class="sharing-list">
          <!-- <network network="facebook" class="sharing-item sharing-item__fb">
            <img src="/static/icons/facebook.svg" alt="Facebook" />
            </network> -->

          <network network="vk" class="sharing-item sharing-item__vk">
            <img src="/static/icons/vk.svg" alt="VK" />
          </network>

          <!-- <network network="linkedin" class="sharing-item sharing-item__ln">
            <img src="/static/icons/linkedin.svg" alt="Linkedin" />
          </network> -->
        </div>
      </social-sharing>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import debounce from 'debounce';
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import CopyTextToClipboard from '@/components/mixin/CopyTextToClipboard.js';
import UrlHistory from '@/routes_new/inner/vacancy/components/UrlHistory';

export default {
  name: 'SettingsSharing',

  components: {
    UrlHistory
  },

  mixins: [SafariBrowserDetector, CopyTextToClipboard, clickaway],

  props: ['token', 'landing_url_path', 'preview_url', 'subdomain', 'localLink'],

  data() {
    return {
      isUrlHistoryVisible: false
    };
  },

  computed: {
    ...mapState('vacancy_new', { vacancy: 'item' }),

    ...mapGetters('company_new', ['isRatesExpired']),

    domain() {
      return `${window.location.origin}/r/`;
    },

    urlHistory() {
      return this.$store.getters['vacancy/url/history'];
    },

    default_link() {
      return `${this.domain}${this.token}`;
    },

    url_path: {
      get() {
        if (this.vacancy.landing_url_path) return this.vacancy.landing_url_path;

        return this.token;
      },

      set(val) {
        this.$store.commit('vacancy/update_link', val);
      }
    },

    landing_url() {
      return this.$store.getters['vacancy/landing_url'];
    },

    err_msg() {
      if (this.landing_url && !this.landing_url.result) {
        return this.landing_url.error.landing_url_path[0];
      } else {
        return '';
      }
    },

    valid_link() {
      const regexp = /[^\d\-_A-Z]/gi; // Значения не попадающие под условие a-Z 0-9 _ и -
      const link = this.url_path.match(regexp);

      if (link || !this.url_path || !this.url_path.length) {
        return false;
      }
      return true;
    },

    custom_link() {
      return this.valid_link ? `${this.domain}${this.url_path}` : this.default_link;
    },

    blocked() {
      if (this.isRatesExpired || !this.valid_link || this.preview_url) {
        return true;
      } else {
        return false;
      }
    },

    copyButtonTooltip() {
      if (this.isRatesExpired) {
        return 'rates.expiredProfile';
      } else {
        return this.blocked ? 'vacancy.preferences.settings.blocked' : 'vacancy.preferences.settings.copyToClipboard';
      }
    },

    previewButtonTooltip() {
      if (this.isRatesExpired) {
        return 'rates.expiredProfile';
      } else {
        return this.blocked ? 'vacancy.preferences.settings.blocked' : 'vacancy.settings.link_clipboard.info';
      }
    }
  },

  watch: {
    valid_link(val) {
      this.$emit('err_save', val);
    },

    err_msg(val) {
      if (val) {
        this.$emit('err_save', false);
      } else {
        this.$emit('err_save', true);
      }
    },

    url_path(val) {
      this.$emit('set_preview_url', true);

      if (val.length >= 1 && this.token !== val && this.valid_link) {
        this.validate(val);
      }
    }
  },

  created() {
    this.$store.commit('vacancy/setChange', false);
    this.$store.commit('vacancy/resetChangesTimestamps');
  },

  methods: {
    copy() {
      if (this.isRatesExpired) {
        return false;
      }

      this.copyLinkToClipboard(this.custom_link);
    },

    preview() {
      window.open(this.custom_link, '_blank');
    },

    focus_area() {
      let link = document.getElementById('registrationLink');
      link.select();
    },

    update_link(val) {
      this.$store.commit('vacancy/update_link', val);
    },

    validate: debounce(function () {
      this.$store.dispatch('vacancy/validate_url').then(() => {
        if (!this.landing_url.result) {
          this.$noty.error(this.err_msg);
        }
      });
    }, 500),

    toggleUrlHistory(val) {
      this.isUrlHistoryVisible = val;
    },

    hideUrlHistory() {
      this.isUrlHistoryVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.sharing-block {
  margin-bottom: 5px;
  width: 100%;
}

.link {
  margin-bottom: 5px;
  font-size: 15px;
  box-sizing: border-box;
  position: relative;

  & > label {
    @include mixin-text-header;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    img {
      margin-left: 4px;
    }
  }

  &__preview {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .link__url {
      width: 100%;
      height: 42px;
      overflow-x: auto;
      display: flex;
      align-items: center;
    }

    span {
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      letter-spacing: 0.005em;
      color: $green;
      white-space: nowrap;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    font-style: normal;
  }

  &__custom {
    display: flex;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 2px;
    width: 100%;
    overflow: hidden;
    align-items: center;
    border-right: none;

    &_error {
      border: 1px solid #f65046;
    }

    .link {
      background: transparent;
      opacity: 0;
      position: absolute;
    }
  }

  &__domain {
    box-sizing: border-box;
    width: auto;
    padding: 10px 0 10px 9px;
    z-index: 9;
    margin-right: -9px;

    span {
      white-space: nowrap;
      color: #9faab6;
    }
  }

  &__area {
    width: 100%;

    ::v-deep .input {
      border-bottom: none !important;
    }
  }

  &_btns {
    display: flex;

    .link-button {
      border: 1px solid #dddddd !important;
      max-height: 42px;
      min-height: 42px;
      width: 42px;
      color: #233346 !important;

      &_right {
        margin-left: 10px;
      }
    }
  }
}

.link-help {
  @include mixin-text-tag;
  margin-bottom: 18px;

  &__error {
    color: $red;
  }
}

.sharing-list {
  display: flex;
  align-items: center;
}

::v-deep .sharing-item {
  margin-right: 10px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  position: relative;
  overflow: hidden;

  &__vk {
    background: #4a76a8;
  }

  &__fb {
    background: #4267b2;
  }

  &__tw {
    background: #50abf1;
  }

  img {
    height: 41px;
    width: auto;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.history-section {
  position: absolute;
  top: 74px;
  left: 0;
  width: calc(100% - 94px);
  background: #fff;
  z-index: 9;
}
</style>
